import styled from "styled-components";
import Glyph12TriangleDown from '@mds/mds-icons/icons/svg/glyph-12-triangle-down.svg';
import Glyph12TriangleUp from '@mds/mds-icons/icons/svg/glyph-12-triangle-up.svg';

export const Wrapper = styled.div`
    padding : 16px 32px;
    padding-bottom: 0px;
    .hide {
        visibility: hidden;
    }
    h1{
        box-sizing: border-box;
        color: rgb(0, 0, 0);
        display: block;
        font-size: 28px;
        font-weight: 500;
        height: 32px;
        line-height: 32px;
        margin-top: 16px;
    }
    button:disabled, input[type=button]:disabled {
        background-color: white !important;
    }
    p{
        box-sizing: border-box;
        color: rgb(77, 77, 77);
        display: block;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-top : 8px;
        word-wrap: break-word;
        a{
            color : #2251ff;
            display: inline-block;
            white-space: nowrap;
        }
    }
    .table-actions{
        display : flex;
        margin: 16px auto;
        align-items : center;
        justify-content: space-between;
    }

    table{
        width : 100%;
        tr:first-of-type th{
            border-bottom : solid thin #000;
            font-weight: 100;
            .sortIcon{
                width : 32px;
                height : 32px;
                vertical-align : middle;
                border : none;
                cursor : pointer;
                background : #000;
                -webkit-mask : url(${Glyph12TriangleUp}) no-repeat center;
                -webkit-mask-size : 8px 8px;
                &.down{
                    -webkit-mask : url(${Glyph12TriangleDown}) no-repeat center;
                    -webkit-mask-size : 8px 8px;
                }
            }
        }
        th,td{
            text-align : left;
            padding : 8px;
            border-bottom : solid thin #ccc;
            font-size : 14px;
            &:first-of-type{
                width : 170px;
            }
            &:nth-child(2){
                width: 410px;
            }
            &:nth-child(3){
                width: 250px;
            }
            &:nth-child(4){
                text-align: left;
            }
            &.downloads-column .buttons {
                display: inline-flex;
                align-items: center;
                justify-content: center;
            }
            &:last-of-type{
                width : 100px;
                text-align: center;
            }
        }
        th {
           span {
            cursor: pointer;
           }
        }
        td{
            height : 24px;
            padding : 0 8px;
            &:hover{
                button.pdf,button.ppt, button.xls{
                    display: inline-block;
                }
                .edit{
                    display: inline-block;
                }
            }
            &.action-column{
                button{
                    box-shadow: none;
                    .mds-button-icon-wrapper{
                        display: none;
                    }
                }
            }
            @keyframes fillCycle {
                0% {
                    width: 0;
                }
                99.9% {
                    width: 100%;
                }
                100% {
                    width: 0;
                }
            }
            color:rgb(51, 51, 51);
            .raw-data-status{
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                min-width: 20px;
                min-height: 20px;
                margin-right: 8px;
                flex-shrink: 0;
                cursor: default;
                vertical-align: middle;
                line-height: 0;
                box-sizing: border-box;
                svg{
                    width: 16px;
                    height: 16px;
                    display: block;
                }
                &.progress{
                    color: #2251ff;
                    overflow: hidden;
                    /* MDS CircularLoading root is flex-column; normalize to centered circle in row */
                    .mds-extra-small,
                    .mds-small {
                        flex-direction: row !important;
                        align-items: center !important;
                        justify-content: center !important;
                        margin: 0 !important;
                        padding: 0 !important;
                        line-height: 0 !important;
                        min-height: 0 !important;
                    }
                    .mds-extra-small > div,
                    .mds-small > div {
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        margin: 0 !important;
                    }
                    svg {
                        display: block;
                        flex-shrink: 0;
                        vertical-align: middle;
                    }
                }
                &.complete{
                    color: #107154;
                }
                &.failed{
                    color: #d51f31;
                }
            }
            button:disabled {
                font-size: 13.33px;
            }
            button.pdf,button.ppt,button.xls{
                position: relative;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                border : solid thin #2251ff;
                min-height : 28px;
                border-radius: 3px;
                padding : 0 8px;
                color : #2251cc;
                background-color: transparent;
                /* display: none; */
                line-height: 1.2;
                margin-right : 8px;
                vertical-align: middle;
                margin-bottom: 1.5px;
                img {
                    height : 16px;
                    width: auto;
                    padding : 0;
                    margin-right: 5px;
                    flex-shrink: 0;
                    vertical-align: middle;
                    align-self: center;
                }
                > span {
                    display: inline-flex;
                    align-items: center;
                }
                &.failed{
                    background-color: #d51f31;
                    border : solid thin #d51f31;
                    color : #fff;
                }
                &.active{
                    background-color: #051c2c;
                    border : solid thin #051c2c;
                    color : #fff;
                    img {
                        filter: brightness(0) invert(1) drop-shadow(0 0 5px rgba(255, 255, 255, 0.8));
                        transform: scale(1.1);
                    }
                    &:hover{
                        border : solid thin #2251ff;
                        background-color: #2251ff;
                        color : #fff;
                    }
                }                
                .progress {
                    background-color: #051c2c;
                    animation: fillCycle 10s linear infinite;
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 0;
                    z-index: 1;
                    opacity: 0.5; 
                }
                .progress + span {
                     color: black;
                }
            }
            button.edit{
                display: none;
                border : none;
                margin-left: 10px;
                padding : 3px;
                color : #2251cc;
                background-color: transparent;
                align-items: center;
                margin-right : 3px;
                vertical-align: middle;
                img{
                    height : 16px;
                    padding : 2px 0;
                    margin-right: 5px;
                    vertical-align: middle;
                }
            }
        }
    }

    .footer-container{
        width : 100vw;
        position : absolute;
        bottom : 0;
        left : 0;
    }

    .table-container{
       flex: 1;
       margin-bottom: 25px;   
       min-height: 40vh;
    }

  .reportPopupWrapper{
    width : 100vw;
    height : 100vh;
    position : fixed;
    z-index : 11;
    background : rgba(0,0,0,0.4);
    top : 0;
    bottom : 0;
    left : 0;
    right : 0;
    display : flex;
    align-items: center;
    justify-content: center;
    .reportPopup{
      min-width: 320px;
      box-sizing: border-box;
      background-color: #fff;
      padding : 40px;
      h1{
        font-size: 24px;
        font-weight: 500;
      }
      p{
        font-size: 14px;
        color : rgb(51,51,51);
        margin-top : 10px;
      }
      input[type=text]{
        color: #333;
        background-color: #fff;
        border: 1px solid #ccc;
        width: 100%;
        height: 38px;
        padding: 8px 12px;
        font-size: 14px;
        line-height: 1.42857;
        box-sizing: border-box;
        display: block;
      }
      .buttons{
        display: flex;
        gap : 10px;
        justify-content: center;
      }
    }
  }  

    .tableWrapper {
        height: auto;
        display: flex;
        flex-direction: column;
    }  
`

export const ErrorMessageContainer = styled.div`
    color: red;
    font-size: 16px;
    padding: 4px;
`;
export const ModalWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 9999;
    
    .mds-modal-cover {
        position: relative;
    }

    > div {
        position: relative;
    }
`;